import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import useAddReport from 'sdk/hooks/useAddReport';
import Button from 'components/shared/Button';
import Modal from 'components/shared/modals/Modal';
import MessageModal from 'components/shared/modals/MessageModal';
import BackBtn from 'components/shared/BackBtn';
import Input from 'components/shared/Input';
import styles from './ReportModal.module.scss';

type ReportModalProps = {
  isOpen: boolean,
  onClose: () => void,
  id: any,
  onBack?: any,
  postId?: any,
  type: string
}

const reasons = [
  { title: 'Minor safety ', id: 'Minor safety ' },
  { title: 'Suicide, self-harm, and disordered eating', id: 'Suicide, self-harm, and disordered eating' },
  { title: 'Adult nudity or sexual activities', id: 'Adult nudity or sexual activities' },
  { title: 'Bullying and harasment', id: 'Bullying and harasment' },
  { title: 'Hateful behavior ', id: 'Hateful behavior ' },
  { title: 'Other', id: 'Other' },
]

function ReportModal({
  isOpen,
  onClose,
  id,
  onBack,
  postId,
  type,
}: ReportModalProps) {
  const [reason, setReason] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const addReportMutation = useAddReport(type, id, `${reason}: ${description}`, postId)
 
  useEffect(() => {
    if (addReportMutation.isSuccess) {
      // commentsData.refetch()
    }
  }, [addReportMutation.isSuccess])

  if (addReportMutation.isSuccess) {
    return (
      <MessageModal
        title="Success"
        status="success"
        onClick={() => {
          addReportMutation.reset()
          onClose()
        }}
        message="You have successfully created your account"
      />
    )
  }

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      className={styles.modal}
    >
      <BackBtn
        className={styles.btnBack}
        onClick={onBack}
      />
      <div className={styles.title}>Report</div>
      <div className={styles.subtitle}>
        What was he talking about?
      </div>
      <div className={styles.description}>
        Select the item you are interested in and send us
      </div>

      {reasons.map((item) => (
        <div
          key={item.id}
          onClick={() => setReason(item.id)}
          className={clsx(styles.reason, (reason === item.id) && styles.reasonActive)}
        >
          {item.title}
          {(reason === item.id) ? (
            <span className={styles.iconActive}><span /></span>
          ) : (
            <span className={styles.iconInactive} />
          )}
        </div>
      ))}

      {
        reason === 'Other' && (
          <Input
            value={description}
            placeholder="Description"
            onChange={(e: React.SyntheticEvent) => { // @ts-ignore
              setDescription(e.target.value)
            }}
          />
        )
      }

      <Button
        className={styles.btn}
        onClick={() => addReportMutation.mutate()}
        wide
        disabled={!reason}
      >
        Send
      </Button>
    </Modal>
  )
}

export default ReportModal
